<template>
  <b-card class="text-center task-card" :class="{ 'item-selected': taskSelect }">
      <template slot="header" class="mb-0" @click="alert('a')">
          <div class="priority-due-section">
          <div class="priority-dot cp" @dblclick="priorityEdit = true" :class="statusColor(item.priority)" v-b-tooltip.hover :title="item.priority"></div>
          <b-form-select v-show="priorityEdit" v-model="item.priority" @change="updatePriority($event)" :options="priorities" required />
          <span><fa v-show="priorityEdit" @click="priorityEdit=false" icon="times-circle"/></span>
          </div>
          <div class="task-text-wrapper cp">
            <span @dblclick="textEdit=!textEdit" v-show="!textEdit" class="task-text">{{item.text}}</span>
            <b-form-textarea v-show="textEdit" v-model="item.text" @dblclick="textEdit=!textEdit" @input="updateText(item)" />
            <span><fa v-show="textEdit" @click="textEdit=false" icon="times-circle"/></span>
          </div>
          <div class="task-actions">
          <span @click="editForm(item)"><fa icon="pen" v-b-modal.task-template /></span>
          <span @click="deleteTemplate(item.id)"><fa icon="trash"/></span>
          <a v-if="item.documentation_link" :href="item.documentation_link" v-b-tooltip.hover title="View docs" target="_blank"><fa icon="question-circle"/></a>
          </div>
      </template>
      <div class="row">
          <div class="col-sm-4">
          <div class="per-client">
              <span class="cp" @dblclick="updatePerClient">Per Client: {{ item.create_per_client }}</span>
          </div>
          </div>
          <div class="col-sm-4">
          <div class="task-value">
              <span class="cp" v-if="valueEdit === false" @dblclick="valueEdit = true">Task Value: {{ item.value }}</span>
              <b-form-select @change="updateValue($event)" v-else type="number" v-model="item.value" :options="[1,2,3,4,5,6,7,8,9,10]"></b-form-select>
              <span><fa v-show="valueEdit" @click="valueEdit=false" icon="times-circle"/></span>
          </div>
          </div>
          <div class="col-sm-4">
          <div v-if="notesEdit === false" class="table-notes table-notes-field cp" @click="notesExpand" @dblclick="notesEdit = true">
              {{item.team_notes}}
          </div>
          <b-form-textarea v-else v-model="item.team_notes" @input="updateTeamNotes(item)" />
          <span><fa v-show="notesEdit" @click="notesEdit=false" icon="times-circle"/></span>
          </div>
      </div>
  </b-card>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'TaskTemplateItem',
  props: ['item'],
  data () {
    return {
      taskSelect: false,
      valueEdit: false,
      notesEdit: false,
      textEdit: false,
      clientEdit: false,
      priorityEdit: false,
      priorities: [
        { text: 'low', value: 'low' },
        { text: 'medium', value: 'medium' },
        { text: 'high', value: 'high' }
      ]
    }
  },
  created () {
    this.$root.$on('resetItemSelect', this.removeItemSelect)
  },
  methods: {
    editForm (task) {
      this.$emit('editform', task)
      this.taskSelect = true
    },
    deleteTemplate (id) {
      this.$emit('deletetemplate', id)
    },
    statusColor (data) {
      if (data !== null) {
        data = data.toLowerCase()
        if (data === 'high') {
          return 'red-status-bg'
        } else if (data === 'medium') {
          return 'yellow-status-bg'
        } else if (data === 'low') {
          return 'green-status-bg'
        } else {
          return 'gray-status-bg'
        }
      } else {
        return 'grey-dot'
      }
    },
    notesExpand () {
      if (event.target.style.whiteSpace === 'normal') {
        event.target.style.whiteSpace = 'nowrap'
      } else {
        event.target.style.whiteSpace = 'normal'
      }
    },
    updatePriority (event) {
      this.priorityEdit = false
      this.item.priority = event
      this.updateTask(this.item)
    },
    updateText: _.debounce(function (item) {
      if (item.text.length > 0 && item.text.replace(/\s/g, '') !== '') {
        this.textEdit = false
        this.updateTask(item)
      }
    }, 2000),
    updatePerClient () {
      this.item.create_per_client = !this.item.create_per_client
      this.updateTask(this.item)
    },
    updateValue (event) {
      this.valueEdit = false
      this.item.value = event
      this.updateTask(this.item)
    },
    updateTeamNotes: _.debounce(function (item) {
      this.notesEdit = false
      this.updateTask(item)
    }, 2000),
    updateTask (task) {
      this.$http.put(('/task_template_collections/' + task.task_template_collection_id + '/task_templates/' + task.id), { task_template: task })
        .then()
        .catch(e => { console.log(e) })
    },
    removeItemSelect () {
      this.taskSelect = false
      console.log('task template item')
    }
  }
}
</script>

<style scoped>
span svg {
  cursor: pointer;
}
.red-status-bg {
  background-color: #ca5935de;
}
.green-status-bg {
  background-color: #8BC34A;
}
.yellow-status-bg {
background-color: #FBC02D;
}
.gray-status-bg {
  background-color: #6C757D;
}
.priority-dot {
  height: 25px;
  width: 25px;
  border-radius: 50%;
}
.btn-action {
  margin-left: 15px;
  margin-top: 15px;
}
.priority-due-section, .task-actions, .task-text-wrapper {
  display: flex;
}
.card-header {
  display: flex;
  justify-content: space-between;
}
.task-actions span {
  margin-right: 5px;
}
.task-card {
  margin-bottom: 1.2rem;
}
.cp {
  cursor: pointer;
}
.item-selected {
  border: 1px solid rgba(0,123,255);
}
.item-selected .card-header {
  background-color: rgba(0,123,255,.3);
  border-bottom: 1px solid rgba(0,123,255);
}
</style>



// WEBPACK FOOTER //
// src/components/admin/TaskTemplateItem.vue